import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
} from '@material-ui/core';
import Button from '../../../components/Button';
import CloseIcon from '@material-ui/icons/Close';

import * as api from '../../../services/api/admin';
import * as adminApi from '../../../services/api/admin';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";


function FAQcreatOrEditeModal(props) {
  const {
    open,
    currentUser,
    providerFaqs,
    setProviderFaqs,
    mode,
    editFaqFaqId,
    onClose,
    classes: {
      modal,
      modalContent,
      input,
      rigthAlign,
      inline,
      submitButton,
    },
  } = props;

  const [Qtext, setQtext] = useState('');
  const [Atext, setAtext] = useState('');
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    (async () => {
      if (mode === 'edit') {
        const faq = await adminApi.getFAQbyIdReq(editFaqFaqId);
        setQtext(faq.q);
        setAtext(faq.a);
      }
    })();
  }, []);
  
  const submitFaq = async () => {
    const sanitizedAnswer = sanitizeLinks(Atext);
    if (mode === 'create') {
      const FaqData = {
        providerId: currentUser.provider.id,
        q: Qtext,
        a: sanitizedAnswer,
        createdBy: currentUser.id
      };
      const newFaq = await api.createFAQreq(FaqData);
      setProviderFaqs([...providerFaqs,newFaq]);
    }else if(mode === 'edit'){
      const FaqData = {
        id: editFaqFaqId,
        q: Qtext,
        a: sanitizedAnswer,
        updatedBy: currentUser.id
      };
      const updatedFaq = await api.updateFAQreq(FaqData);
      let temp = [...providerFaqs];
      temp= temp.map(faq => faq.id === editFaqFaqId? updatedFaq : faq )
      setProviderFaqs(temp);
    }
      setQtext('');
      setAtext('');
      onClose();
  }


  const validate =async  () => {
    let valid = true;
    let nextState = {};
      if (!Qtext) {
        valid = false;
        nextState.Qtext = 'Required';
      }
      if (!Atext) {
        valid = false;
        nextState.Atext = 'Required';
      }
    await setValidationErrors(nextState);
    return valid;
  };

  const normalizeUrl = (url) => {
    if (!/^https?:\/\//i.test(url)) {
      return 'https://' + url;
    }
    return url;
  };

  const sanitizeLinks = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;

    const anchors = div.querySelectorAll('a');
    anchors.forEach(a => {
      const href = a.getAttribute('href');
      if (href) {
        a.setAttribute('href', normalizeUrl(href));
      }
    });

    return div.innerHTML;
  };

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    if (open) {
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    } else {
      html.style.overflow = '';
      body.style.overflow = '';
    }

    return () => {
      html.style.overflow = '';
      body.style.overflow = '';
    };
  }, [open]);

  return (
      <Dialog
        fullWidth
        open={open}
        onClose={onClose}
        classes={{ paper: modal }}
      >
        <DialogTitle className="headingSize">
          <h2 className ={inline} >{mode==='create'?"Add New FAQ" : "Update FAQ"}</h2>
          <IconButton className ={rigthAlign} aria-label="Close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent classes={{ root: modalContent }}>
          <h2><strong>Question:</strong></h2>
          <TextField
            variant="outlined"
            name="question"
            value={Qtext}
            className={input}
            fullWidth
            onChange={event => setQtext(event.target.value.substring(0, 160))}
            multiline
            rows="4"
            helperText={validationErrors.Qtext?
               validationErrors.Qtext:"Type a frequently asked question " + Qtext.length + "/160"}
            error = {!!validationErrors.Qtext}
          />

          <h2 ><strong>Answer:</strong></h2>
          <ReactQuill
              value={Atext}
              onChange={(value) => setAtext(value)}
              modules={{
                toolbar: [
                  // [{ 'header': [1, 2, false] }],
                  // ['bold', 'italic', 'underline', 'strike'],
                  // ['blockquote', 'code-block'],
                  // [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                  ['link'],
                  // ['clean'],
                ],
              }}
              formats={[
                'header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block',
                'list', 'bullet', 'link',
              ]}
            />
            <p className='MuiFormHelperText-root MuiFormHelperText-contained MuiFormHelperText-filled'>Paste or type a URL (e.g. google.com or https://example.com), then click the link icon to make it clickable.</p>
          {/* <TextField
            variant="outlined"
            fullWidth
            name="answer"
            value={Atext}
            className={input}
            onChange={event => setAtext(event.target.value.substring(0, 255))}
            multiline
            rows="7"
            helperText={validationErrors.Atext?
              validationErrors.Atext:"Type an answer " + Atext.length + "/255"}
            error = {!!validationErrors.Atext}
          /> */}
          <div className="subBtn" style={{display:'flex',justifyContent:'end',marginTop: '50px'}}>
          <Button
            onClickSuccessSnackbar= {"FAQ was successfully " + (mode==='create'? "submitted." : "updated.")}
            onClickFailSnackbar={"FAQ could not be " + (mode==='create'? "submitted." : "updated.")}
            color="primary"
            variant="contained"
            onClick={submitFaq}
            onClickValidation={validate}
            className= {submitButton}
          >
            Submit
          </Button>
          </div>
        </DialogContent>
      </Dialog>
  );
}

const styles = () => ({
  modal: {
    maxWidth: '600px',
  },
  modalContent: {
    overflow: 'visible',
  },
  selectInput: {
    margin: '0.5em',
  },
  input: {
    margin: '0.2em',
    marginRight: 'auto',
    marginLeft: 'auto',
    marginBottom: '20px',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  helperText: {
    margin: '0 0 -2em 2em'
  },
  submitButton: {
    marginBottom: '10px',
  },
  rigthAlign: {
    float: 'right'
  },
  block: {
    display: 'block'
  },
  inline: {
    display: 'inline-block',
  },
});

export default withStyles(styles)(FAQcreatOrEditeModal);
